<ul class="nav nav-pills mb-3">
    <li class="nav-item">
        <a
            class="nav-link"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }"
            routerLink="/smartquotes"
            >Smartquotes</a
        >
    </li>
    <li class="nav-item">
        <a
            class="nav-link"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }"
            routerLink="/smartquotes/statistics"
            >Statistics</a
        >
    </li>
</ul>
